/// <amd-module name="Artifacts/Root/types/IRetentionPolicy" />

/**
 * Feed data we need for the feed list
 */
export interface IRetentionPolicy {
  /** TODO: this should come from the service as well */
  isEnabled: boolean;
  /**
   * Maximum versions to preserve per package and package type.
   */
  countLimit: number;
  /**
   * Number of days to preserve a package version after its latest download.
   */
  daysToKeepRecentlyDownloadedPackages: number;
}
